import { Stack } from "PFComponents/containers";
import { SuspendedPill } from "PFComponents/suspended_pill";
import { Typography } from "PFComponents/typography";
import { useUnbiasedProfileName } from "PFCore/hooks/use_unbiased_profile_name";

import { ProfileFrom } from "../../parts/overview/booking_module_calendar/context/reassign_action_context_provider";
import css from "./profile_item_display.module.scss";

type ProfileItemDisplayProps = {
  profile: ProfileFrom;
};

export const ProfileItemDisplay = ({ profile }: ProfileItemDisplayProps) => {
  const { getUnbiasedProfileName } = useUnbiasedProfileName();

  const profileName = getUnbiasedProfileName(profile, !!profile.unbiased);
  const profileEmail = profile.unbiased ? undefined : profile.email;

  return (
    <Stack gap="spacingSm">
      <Typography variant="h5" className={css.wrappedContainer}>
        {profileName}
      </Typography>
      {!!profileEmail && (
        <Typography withMargin variant="bodyRegular" tag="span" className={css.wrappedContainer}>
          {profileEmail}
        </Typography>
      )}
      {!!profile.suspendedAt && <SuspendedPill suspendedAt={profile.suspendedAt} className={css.suspended} />}
    </Stack>
  );
};
